module.exports = __webpack_public_path__ + "a25159f912c9595b5ce2e9029daad8ce.MP3";